import DeviceTypeSelect from './DeviceTypeSelect';

export default DeviceTypeSelect;
